(function (angular) {
	'use strict';

	var loaderObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			loading: '<',
			gray: '<?'
		},
		controllerAs: 'loader'
	};

	angular
		.module('loaderModule')
		.component('loader', loaderObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/loader/loader.html';
	}
})(window.angular);